import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import esCommon from "./locales/es/common.json";
import esTopbar from "./locales/es/topbar.json";
import esFooter from "./locales/es/footer.json";
import esHome from "./locales/es/home.json";
import esNosotros from "./locales/es/nosotros.json";
import esSolutions from "./locales/es/solutions.json";
import esCampaing from "./locales/es/campaing.json";
import esMarketing from "./locales/es/marketing.json";
import esModuleCount from "./locales/es/modulecount.json";
import esModuleCharacterization from "./locales/es/modulecharacterization.json";
import esPolicies from "./locales/es/policies.json";
import esPdf from "./locales/es/pdf.json";
import esImportant from "./locales/es/important.json";
import esPrices from "./locales/es/prices.json";
import esConfirmation from "./locales/es/confirmation.json";
import esContact from "./locales/es/contact.json";
import esBlog from "./locales/es/blog.json";

import enCommon from "./locales/en/common.json";
import enTopbar from "./locales/en/topbar.json";
import enFooter from "./locales/en/footer.json";
import enHome from "./locales/en/home.json";
import enNosotros from "./locales/en/nosotros.json";
import enSolutions from "./locales/en/solutions.json";
import enCampaing from "./locales/en/campaing.json";
import enMarketing from "./locales/en/marketing.json";
import enModuleCount from "./locales/en/modulecount.json";
import enModuleCharacterization from "./locales/en/modulecharacterization.json";
import enPolicies from "./locales/en/policies.json";
import enPdf from "./locales/en/pdf.json";
import enImportant from "./locales/en/important.json";
import enPrices from "./locales/en/prices.json";
import enConfirmation from "./locales/en/confirmation.json";
import enContact from "./locales/en/contact.json";
import enBlog from "./locales/en/blog.json";

export const LANGUAGE_STORAGE_KEY = "switch_lang";

const resources = {
  es: {
    common: esCommon,
    topbar: esTopbar,
    footer: esFooter,
    home: esHome,
    nosotros: esNosotros,
    solutions: esSolutions,
    campaing: esCampaing,
    marketing: esMarketing,
    modulecount: esModuleCount,
    modulecharacterization: esModuleCharacterization,
    policies: esPolicies,
    pdf: esPdf,
    important: esImportant,
    prices: esPrices,
    confirmation: esConfirmation,
    contact: esContact,
    blog: esBlog,
  },
  en: {
    common: enCommon,
    topbar: enTopbar,
    footer: enFooter,
    home: enHome,
    nosotros: enNosotros,
    solutions: enSolutions,
    campaing: enCampaing,
    marketing: enMarketing,
    modulecount: enModuleCount,
    modulecharacterization: enModuleCharacterization,
    policies: enPolicies,
    pdf: enPdf,
    important: enImportant,
    prices: enPrices,
    confirmation: enConfirmation,
    contact: enContact,
    blog: enBlog,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    nonExplicitSupportedLngs: true,
    defaultNS: "common",
    ns: Object.keys(resources.es),
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
